import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';

export const isFullscreenProductModalEnabled = () => {
  return EnterpriseExperiments.get('fullscreenProductModal');
};

export const doesEnterpriseSearchOpenInNewWindow = () => {
  return EnterpriseExperiments.get('openSearchInNewPage');
};
